import { render, staticRenderFns } from "./CalendarPoints.vue?vue&type=template&id=5b6fbaf8&scoped=true&"
import script from "./CalendarPoints.vue?vue&type=script&lang=js&"
export * from "./CalendarPoints.vue?vue&type=script&lang=js&"
import style0 from "./CalendarPoints.vue?vue&type=style&index=0&id=5b6fbaf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6fbaf8",
  null
  
)

export default component.exports